import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-ads',
)({
  component: () => <Outlet />,
});
